<template>
  <div>
    <p class="gp-option-list-title">{{ title }}</p>
    <ul class="gp-option-list">
      <li
        class="gp-option"
        :class="{ 'gp-option-selected': isSelected(option) }"
        v-for="option of options"
        :key="option.position"
        @click="selectOption(option)"
      >
        {{ option.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OptionList",

  props: ["options", "title", "module"],

  methods: {
    selectOption(option) {
      this.$emit("select", option);
    },

    isSelected(option) {
      let selection = this.$store.state[this.module].selection;
      if (!selection) return false;

      return selection.name === option.name;
    },
  },
};
</script>

<style></style>
